import {  
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow 
} from '@material-ui/core'
import React, {useEffect, useState} from 'react'; 
import { EncryptStorage } from "encrypt-storage";
import Axios from 'axios'; 
import CreateOrUpdateFutureSched from '../../../_modal/CreateOrUpdateFutureSched';
import Skeleton from '@material-ui/lab/Skeleton';

export default function WorkScheduleChanges () {
    const [loading, setLoading]                                 = useState(false);
    const encryptStorage                                        = new EncryptStorage("secret-key");
    const decypt_data                                           = encryptStorage.getItem("client_case_id"); 
    const [futureSchedule, setFutureSchedule]                   = useState('N/A');

    useEffect(() => {
        setLoading(true);
        Axios.get(`api/work/schedule/list/${decypt_data}`)
        .then((e)=>{   
            if(e.data.data.length != 0) { 
                setFutureSchedule(e.data.data[0].work_sched_changes === null ? "N/A" : e.data.data[0].work_sched_changes);    
            }
            setLoading(false); 
        });
    }, []);

    const createOrUpdate =(values)=> { 
        Axios.post(`api/work/schedule`, values)
        .then((e)=>{  
            setFutureSchedule(e.data.data[0].work_sched_changes === null ? "N/A" : e.data.data[0].work_sched_changes);    
        });
    }

    return (
        <div className={`card h-100 card-custom `}>
            <div className="card-header border-0">
                <h3 class="card-title d-flex align-items-start flex-column align-self-center">
                    <span class="card-label font-weight-bolder text-dark">
                    Work Schedule Changes
                    </span>
                    <span class="text-muted mt-0 font-weight-bold font-size-sm">
                    If you anticipate future work schedule changes for either parent, please explain below. 
                    </span>
                </h3>
                <div className="card-toolbar">
                    <CreateOrUpdateFutureSched createOrUpdate={createOrUpdate}/> 
                </div>
            </div>
            <hr/>
            <div className="card-body pt-2">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Future Changes to Schedule</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                            {
                                loading ? 
                                <TableRow>
                                    <TableCell>
                                        <Skeleton variant="rect" animation="wave" width={'100%'} height={25} /> 
                                    </TableCell>
                                </TableRow>
                                : 
                                <TableRow>
                                    <TableCell className={"text-capitalize"}>{futureSchedule}</TableCell>
                                </TableRow>
                            }
                    </TableBody>
                </Table> 
            </div>
        </div>
    )
}